import { Locale } from "date-fns";

export const formatIntlNumber = (value: number, locale: Locale) => {
  return new Intl.NumberFormat(locale.code, { maximumSignificantDigits: 3 }).format(value);
};
